import React, { PureComponent } from 'react';
import { Alert, Spin } from 'antd';
import './NetworkDetector.scss';
export class Offline extends PureComponent {
  constructor() {
    super(...arguments);
    this._renderMessage = () => /*#__PURE__*/React.createElement("div", null, "Trying to reconnect. Please check your internet connection.", /*#__PURE__*/React.createElement(Spin, {
      size: "small",
      style: {
        marginLeft: '16px'
      }
    }));
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "approot-bar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "approot-bar-message"
    }, /*#__PURE__*/React.createElement(Alert, {
      banner: true,
      message: this._renderMessage()
    })));
  }
}
;
export default Offline;